import { useEffect, useRef } from 'react'

// Guarda de "dados não salvos" para o ESC global (Layout).
// Uma tela registra se está "suja" (tem dados não salvos). Enquanto ela estiver
// montada, o ESC global pergunta "Descartar alterações?" antes de sair dela.
// Singleton simples: só há uma tela de formulário ativa por vez no roteamento.
let dirtyGetter: (() => boolean) | null = null

export function hasUnsavedChanges(): boolean {
  try {
    return !!dirtyGetter && dirtyGetter()
  } catch {
    return false
  }
}

// Registra a tela atual. Lê sempre o valor mais recente de isDirty via ref,
// então basta chamar o hook uma vez passando a condição reativa.
export function useUnsavedGuard(isDirty: boolean) {
  const ref = useRef(isDirty)
  ref.current = isDirty
  useEffect(() => {
    dirtyGetter = () => ref.current
    return () => { dirtyGetter = null }
  }, [])
}

// O Layout registra aqui como abrir o modal "Descartar alterações?".
let promptHandler: ((acao: () => void) => void) | null = null
export function registerDiscardPrompt(fn: ((acao: () => void) => void) | null) { promptHandler = fn }

// Navega pedindo confirmação se houver dados não salvos; senão navega direto.
// Use nos botões "Voltar"/ações de saída de telas de formulário.
export function guardedNavigate(acao: () => void) {
  if (hasUnsavedChanges() && promptHandler) promptHandler(acao)
  else acao()
}
